module.exports = "<div class=\"next-tree\">\r\n  <div class=\"menu-item-next\" *ngFor=\"let item of data\">\r\n    <div *ngIf=\"item['url']\" routerLink=\"{{item['url']}}\" (click)=\"appFuncs.toTop()\" [ngClass]=\"{'menu-item-next-text': item['url']}\">\r\n      - {{item.title}}\r\n    </div>\r\n    <div *ngIf=\"!item['url']\">\r\n      - {{item.title}}\r\n    </div>\r\n    <my-menu *ngIf=\"item['childs']\" [data]=\"item['childs']\"></my-menu>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/menu/menu.component.html
// module id = 116
// module chunks = 1